module.exports = __webpack_public_path__ + "img/promoIndex.ffba1621.jpg";